module.exports = __webpack_public_path__ + "static/media/bg1.0c51244f.png";